export { default as triageBackgroundMobile } from './triageBackgroundMobile.jpg'
export { default as CurvedHeaderDesktop } from './CurvedHeaderDesktop.png'
export { default as CurvedHeaderLaptop } from './CurvedHeaderLaptop.png'
export { default as CurvedHeaderTablet } from './CurvedHeaderTablet.png'
export { default as CurvedHeaderMobile } from './CurvedHeaderMobile.png'
export { default as WellnessToolkitHeaderImage } from '../WellnessToolkitHeader.png'
export { default as WellnessToolkitMobileHeaderImage } from '../WellnessToolkitMobileHeader.png'
export { default as sliderThumb } from '../sliderThumb.png'
export { default as WellnessCheckInResultsHeader } from '../WellnessCheckInResultsHeader.png'
export { default as WellnessCheckInResultsHeaderTablet } from '../WellnessCheckInResultsHeaderTablet.png'
export { default as WellnessCheckInResultsHeaderMobile } from '../WellnessCheckInResultsHeaderMobile.png'
export { default as WellnessCheckInResultsHeaderMobilePlus } from '../WellnessCheckInResultsHeaderMobilePlus.png'
